import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

export function buildMapSearchThisAreaActivityEntry(categoryLabel: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'map_search_this_area',
    label: 'Searched map area',
    displayText: boundActivityDisplayText(`Searched this area for "${categoryLabel}"`),
    sourcePath: 'trip_planner.map.search_this_area',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
